import { useTranslation } from 'next-i18next'
import { PieChart } from 'react-minimal-pie-chart'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import useAvatarImageUrl from '~/dashboard/hooks/useAvatarImageUrl'
import { selectPoints } from '~/gamification/slices/gamification.slice'
import { OutfitGender } from '~/homebase/types/Homebase.types'
import useCalculateLevel from '~/hooks/useCalculateLevel'
import useCurrentUser from '~/hooks/useCurrentUser'
import { useGetAvatarMetadataQuery } from '~/redux/apis/user-api'
import { useAppSelector } from '~/redux/hooks'
import { IUser } from '~/types/user-info-types'

export default function SetCompletedAvatar({ isEndOfLevel }: { isEndOfLevel?: boolean }): React.ReactElement {
  const { t } = useTranslation('homebase')
  const user = useCurrentUser()
  const avatarImageObject = useAvatarImageUrl()
  const { data: metadata } = useGetAvatarMetadataQuery(user as IUser, { skip: !user?.avatarUrl })
  const points = useAppSelector(selectPoints) || 0
  const userLevelData = useCalculateLevel(points)

  return (
    <div className="relative flex flex-col items-center justify-center w-52 h-3/5">
      <div className="bg-purple-medium-top w-44 h-44 m-auto rounded-full flex flex-col items-center justify-center p-4 shadow-task-purple-light z-10">
        <div className="absolute z-10 w-44 h-44">
          <PieChart
            className="drop-shadow-white-xs duration-300"
            data={
              userLevelData.xpGainedThisLvl > 0
                ? [{ value: userLevelData.xpGainedThisLvl, key: 1, color: '#6525B6' }]
                : []
            }
            lineWidth={8}
            radius={47}
            rounded
            startAngle={90}
            totalValue={userLevelData.xpToNextLvl}
          />
        </div>
        <div className="w-full h-fulll rounded-full bg-white overflow-hidden m-auto">
          {avatarImageObject.isUnder13 || !avatarImageObject.isExists ? (
            <ResponsiveImage
              alt={t('yourAvatar')}
              height={410}
              imageClassName={metadata?.outfitGender === OutfitGender.FEMININE ? '-mt-8' : ''}
              imageWidths="300"
              srcKey={avatarImageObject.url}
              width={318}
            />
          ) : (
            <ResponsiveImage
              alt={t('yourAvatar')}
              className="overflow-hidden"
              height={250}
              imageClassName={`w-64 h-64 max-w-100 -ml-13 ${
                metadata?.outfitGender === OutfitGender.FEMININE ? '-mt-8' : ''
              }`}
              imageWidths="250"
              loading="eager"
              src={`${avatarImageObject.url}?size=300`}
              width={250}
            />
          )}
        </div>
      </div>
      <div
        className={`left-0 right-0 mx-auto flex justify-center relative items-center w-10 z-10 ${
          isEndOfLevel ? '-top-10' : '-top-8'
        }`}
      >
        <p className="absolute block -mt-4 text-white z-10">{userLevelData.lvl}</p>
        <ResponsiveImage
          alt={t('imageAlt.levelBadge')}
          height={54}
          imageClassName="w-10"
          srcKey="gamification/user-level-badge.png"
          width={40}
        />
      </div>
    </div>
  )
}
